import { useContext } from 'react';
import OptInWidget from '../../../editor/features/build/requestModels/widgets/OptInWidget';
import { useWidgetCRUDActions } from '@mm/state/actions/WidgetCRUDActions';
import ButtonModel, { PageButtonConfig } from '@mm/state/model/ButtonModel';
import { PathGraphContext } from '../../widgets/common/PathGraph/PathGraph';
import { useCommonWidgetHandlers } from './use-common-widget-handlers';
import { usePageCRUDActions } from '@mm/state/actions/PageCRUDActions';
import { useSelector } from 'react-redux';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';

export const useOptInWidgetHandlers = () => {
  const commonWidgetHandlers = useCommonWidgetHandlers();
  const widgetCRUDActions = useWidgetCRUDActions();
  const pageCRUDActions = usePageCRUDActions();

  const chatbotId = useSelector(activeChatbotIdSelector);

  const { addDialogueWidgetsToGraph } = useContext(PathGraphContext);

  const addNew = async (dialogueId: number, sortOrder: number) => {
    const newWidget = OptInWidget.make(dialogueId, sortOrder);

    const createdWidget = await commonWidgetHandlers.create(
      newWidget,
      dialogueId,
      sortOrder,
    );

    if (createdWidget) {
      await pageCRUDActions.retrieveAll(chatbotId);
      addDialogueWidgetsToGraph?.([createdWidget]);
      const widgetButtons = (createdWidget.buttons as ButtonModel[]) || [];
      const newlyAddedDialogueIds = widgetButtons
        .map(b => (b.config as PageButtonConfig).pageId)
        .filter(id => id);

      await Promise.all(
        newlyAddedDialogueIds.map(id =>
          widgetCRUDActions.retrieveAll(id, true),
        ),
      );
    }
    return createdWidget;
  };

  return {
    delete: commonWidgetHandlers.delete,
    updateOptIn: commonWidgetHandlers.updateBodyText,
    addNew,
  };
};
